import { NavLink } from 'react-router';
import { twMerge } from 'tailwind-merge';

import { rewardTypeSelectButtonsStyles, tabsStyles } from '../styles';
import { SvgIconNavApp } from '../svg/icon-nav-app';
import { SvgIconNavService } from '../svg/icon-nav-service';
import { SvgIconNavShopping } from '../svg/icon-nav-shopping';

const allItems = [
  {
    key: 'shopping',
    title: (
      <>
        お買い物で
        <br className="lg:hidden" />
        株をもらう
      </>
    ),
    img: SvgIconNavShopping,
    to: '/#globalMenu',
  },
  {
    key: 'application',
    title: (
      <>
        スマホアプリで
        <br />
        株をもらう
      </>
    ),
    img: SvgIconNavApp,
    to: `${import.meta.env.VITE_APPLICATION_TOP_ROUTE}#globalMenu`,
  },
  {
    key: 'service',
    title: (
      <>
        登録や申込で
        <br className="lg:hidden" />
        株をもらう
      </>
    ),
    img: SvgIconNavService,
    to: `${import.meta.env.VITE_SERVICE_TOP_ROUTE}#globalMenu`,
  },
];

export const SiteGlobalMenu = ({ isMobileOrTablet }: { isMobileOrTablet: boolean }) => {
  const menuItems = isMobileOrTablet
    ? allItems
    : allItems.filter((item) => item.key === 'shopping' || item.key === 'service');

  const listStyles = isMobileOrTablet
    ? 'border-brand grid w-full scroll-mt-26 grid-cols-3 gap-2 border-b px-3 '
    : twMerge(tabsStyles.list, ' grid md:scroll-mt-32');

  const triggerStyles = isMobileOrTablet
    ? rewardTypeSelectButtonsStyles.base
    : twMerge(tabsStyles.trigger, 'flex flex-col items-center');

  const triggerActiveStyles = isMobileOrTablet
    ? rewardTypeSelectButtonsStyles.active
    : twMerge(
        tabsStyles.trigger,
        'border-brand text-grey-900 hover:border-brand hover:text-grey-900 hover:cursor-default'
      );

  return (
    <div className={listStyles} id="globalMenu">
      {menuItems.map((item) => (
        <NavLink
          key={item.key}
          to={item.to}
          className={({ isActive }) => (isActive ? twMerge(triggerStyles, triggerActiveStyles) : triggerStyles)}>
          <div className="mb-2 flex h-12 w-12 items-center justify-center md:h-[60px] md:w-[60px]">
            <item.img className="md:h-auto md:w-[60px]" />
          </div>

          <div className="text-center leading-tight">
            <div className="md:text-headline-xs text-button-m font-bold whitespace-nowrap">{item.title}</div>
          </div>
        </NavLink>
      ))}
    </div>
  );
};
